import { useState, useEffect } from "react";

export default function useCarrierLedgerCharges(carrierExtraPay, load) {
  const [carrierLinehaul, setCarrierLinehaul] = useState(0);
  const [carrierFuel, setCarrierFuel] = useState([]);
  const [carrierAccessorials, setCarrierAccessorials] = useState([]);
  const [paidCarrierComchecks, setPaidCarrierComchecks] = useState([]);

  const carrierFuelCode = "FS";
  const paidComchecksAccessorialCodes = ["COM"];

  useEffect(() => {
    setCarrierLinehaul(load.carrierLinehaul ?? 0);
    setCarrierFuel(carrierExtraPay.filter(pay => pay.deductCodeId === carrierFuelCode));
    setCarrierAccessorials(carrierExtraPay.filter(pay =>
      pay.deductCodeId !== carrierFuelCode && !paidComchecksAccessorialCodes.includes(pay.deductCodeId)
    ));
    setPaidCarrierComchecks(carrierExtraPay.filter(pay => 
      pay.deductCodeId !== carrierFuelCode && paidComchecksAccessorialCodes.includes(pay.deductCodeId)
    )); 
  }, [load, carrierExtraPay]);

  return {carrierLinehaul, carrierFuel, carrierAccessorials, paidCarrierComchecks};
}